export default {
  title: {
    purchaseOrder: 'Purchase Order (PR)',
    importCertificate: 'Import Certificate',
    productList: 'Product List',
    purchaseResForm: 'Purchase Requisition Form',
    importResForm: 'Import Request Form'
  },
  placeholder: {
    searchPR: 'Search Purchase Order Code (PR)',
    searchIC: 'Search Import Certificate Code',
    searchIdName: 'Search Product Code or Product Name',
    selectAll: 'Select All',
    selectCreateDate: 'Select Creation Date',
    enterSaler: 'Enter Supplier',
    enterDealer: 'Enter Dealer',
    plzEnterQty: 'Please enter import quantity'
  },
  label: {
    id: 'Code',
    product: 'Product',
    ingredient: 'Ingredient',
    createDate: 'Creation Date',
    orderDate: 'Order Date',
    drugFormula: 'Medicine Formula',
    saler: 'Supplier',
    dealer: 'Dealer',
    orderer: 'Orderer',
    prescriber: 'Prescriber',
    resReviewer: 'Request Reviewer',
    approver: 'Approver',
    tax: 'Tax Invoice',
    haveTax: 'Has Tax Invoice',
    buyPrice: 'Purchase Price',
    qtyImports: 'Import Quantity',
    outstandImports: 'Outstanding Import Quantity',
    productType: 'Product Type',
    licenseNo: 'License Number',
    PRNo: 'PR Number'
  },
  header: {
    PRId: 'Purchase Order Code',
    ICId: 'Import Certificate Code',
    idNameIngredient: 'Ingredient Code - Name',
    idNameProduct: 'Product Code - Name',
    date: 'Date',
    createDate: 'Creation Date',
    createBy: 'Created By',
    recipient: 'Recipient',
    type: 'Type',
    status: 'Status',
    tax: 'Tax Invoice',
    stock: 'Stock',
    unit: 'Unit',
    list: 'List',
    pricePerUnit: 'Purchase Price per Unit',
    qty: 'Order Quantity'
  },
  state: {
    all: 'All',
    wait: 'Pending Receipt',
    received: 'Received',
    cancel: 'Cancelled'
  },
  toolTip: {
    seePR: 'View Purchase Order',
    seeIC: 'View Import Certificate',
    edit: 'Edit',
    editPR: 'Edit Purchase Order',
    editIC: 'Edit Import Certificate',
    delete: 'Delete',
    createIC: 'Create Import Certificate',
    createPR: 'Create Purchase Order',
    cancelPR: 'Cancel Purchase Order'
  },
  alert: {
    PRcreate: 'Purchase Order created successfully',
    PRedited: 'Purchase Order edited successfully',
    deleted: 'Product deleted successfully',
    PRdeleted: 'Purchase Order deleted successfully',
    ICdeleted: 'Import Certificate deleted successfully',
    plzEnter: 'Please add items before creating a Purchase Order',
    plzAddPr: 'Please add order items before creating Import Certificate!'
  },
  modal: {
    titleDelete: 'Confirm Purchase Order Deletion',
    subTitleDelete: 'You are deleting a purchase order. Do you want to continue?'
  }
}
